import React, { ComponentProps } from 'react';

import { Text } from '@zapier/design-system';

type Props = ComponentProps<typeof Text>;

function Paragraph(props: Props) {
  const { children, ...restProps } = props;

  return (
    <Text {...restProps} margin="0 0 22px" tag="p">
      {children}
    </Text>
  );
}

export default Paragraph;
